

import useVuelidate from '@vuelidate/core'
import { required, email, minLength } from '@vuelidate/validators'

const mustBePhoneNumber = (value) => {
    const val = value.replaceAll(' ', '');
    return /^([0-9]{10,})$/.test(val);
}

export default {
    head() {
        return {
            title: this.offreAlternance?.attributes?.metaTitle ? `${this.offreAlternance?.attributes?.metaTitle}` : `ICFA - Offre - ${this.offreAlternance?.attributes?.titre} `,
            meta: this.offreAlternance?.attributes?.meta != null && this.offreAlternance?.attributes?.meta != undefined ?
                JSON.parse(this.campusInfo?.attributes?.metaOffreAlt?.replace('\n', '')) : null
        };
    },
    data() {
        const strapiBaseUri = process.env.strapiBaseUri

        const isOpen = false
        const dublon = false

        let candidatureForm = {
            prenom: '',
            nom: '',
            dateOfBirth: '',
            codePostal: '',
            ville: '',
            bacSerie: '',
            bac: '',
            mobilite: '',
            email: '',
            telephone: '',
            resumeProjet: '',
            civilite: '',
            planRegion: '',
            consent: '',
            cv: null,
        };
        let listCities = [];

        let formSent = false;

        let sending = false;

        return {
            strapiBaseUri,
            candidatureForm,
            listCities,
            departementExplantionNeeded: false,
            formSent, sending,
            isMounted: false,
            isOpen,
            dublon
        }
    },
    mounted() {
        this.isMounted = true;
    },
    setup() {
        return { v$: useVuelidate() }
    },
    validations() {
        return {
            candidatureForm: {
                prenom: { required },
                nom: { required },
                dateOfBirth: { required },
                codePostal: { required },
                ville: { required },
                bacSerie: { required },
                bac: { required },
                mobilite: { required },
                email: { required, email },
                telephone: { required, mustBePhoneNumber, minLength: minLength(10) },
                civilite: { required },
                consent: { required },
                planRegion: this.departementExplantionNeeded ? { required } : {},

            }

        }
    },
    methods: {
        checkCandidatureForm() {

        },
        resetInput() {
            this.candidatureForm.cv = null;
        },
        previewFiles(event) {
            this.candidatureForm.cv = event.target.files[0];
        },
        chooseFiles: function () {
            document.getElementById("fileUpload").click()
        },
        giveMonth(date) {
            let splitedDate = date.split('-');
            let newDate = new Date(splitedDate[0], splitedDate[1] - 1, splitedDate[2]);
            return newDate.toLocaleString('default', { month: 'long' });
        },
        clickSeries() {
            this.displayedBacs = this.bacs.filter(bac => bac.serie === this.candidatureForm.bacSerie)
        },
        async sendStudent() {

            try{
                if (await this.v$.$validate()) {
                    this.sending = true;

                    this.candidatureForm.diplome = this.offreAlternance.attributes.diplome.data.attributes.idDiplomeCRM;
                    this.candidatureForm.session = this.sessionInfo.attributes?.idSessionCRM;
                    this.candidatureForm.campus = this.instance.attributes.idCampusCRM;
                    this.candidatureForm.url = window.location.host + "" + this.$nuxt.$route.path;
                    // send diplomq ID and prefix of campus
                    this.candidatureForm.campusDiplomaId = this.campusDiploma.id;
                    this.candidatureForm.campusPrefix = this.instance.attributes.prefix;
                    this.candidatureForm.isOffre = true;
                    this.candidatureForm.diplomaAcronyme = this.offreAlternance.attributes.diplome.data.attributes.acronyme;
                    this.candidatureForm.campusName = this.instance.attributes.name;
                    this.candidatureForm.utm = JSON.stringify(this.$store.state.utm);

                    let formData = new FormData();
                    formData.append('cv', this.candidatureForm.cv);
                    this.candidatureForm.cv = this.candidatureForm.cv?.name
                    formData.append('data', JSON.stringify(this.candidatureForm));

                    let result = await this.$http.$post(`${process.env.apiCrmServer}candidature_form_offre_emploi.php?`, formData);

                    if (result == "success") {
                        this.formSent = true;
                    } else if(result.code == 'alreadyExist'){
                        // display popup
                        this.sending = false;
                        this.dublon = true;
                        this.isOpen = true;
                    }
                    else {
                        this.sending = false;
                        this.isOpen = true
                    }
                }
            }
            catch(error){
                this.sending = false;
                this.isOpen = true
            }

        },
        async changeCodePostal() {

            this.candidatureForm.ville = ''

            let listCities = await this.$http.$get(`${process.env.apiCrmServer}villes.php?code_postal=${this.candidatureForm.codePostal}`);
            this.listCities = listCities.data;
            if (this.candidatureForm.codePostal.length > 4 && this.candidatureForm.codePostal.substring(0, 2) != '34' && this.candidatureForm.codePostal.substring(0, 2) != '30') {
                this.departementExplantionNeeded = true
            } else {
                this.departementExplantionNeeded = false
            }
        },
    },


    async asyncData({ params, $http, store, redirect }) {
        // let instances = await $http.$get(`${process.env.strapiBaseUri}/api/instances`);
        // instances = instances.data;
        let instances = store.state.instances;

        const instance = instances.filter((instance) => {
            return instance.attributes.subFolderName == params.campusHP
        })[0];

        if(!instance){
            // redirect to lost page
            redirect('/404-error/')
        }

        let detailInfo = store.state.detailInfo;

        let offreAlternanceID = params.offre.split('-').slice(-1)[0]

        let offreAlternance
        try {
            offreAlternance = await $http.$get(`${process.env.strapiBaseUri}/api/${instance.attributes.prefix}-offre-alternances/${offreAlternanceID}?populate=imageOfferAlternance,diplome`);
            offreAlternance = offreAlternance.data;
        } 
        catch(error) {
            // redirect to lost page
            redirect('/404-error/')
        }

        let campusDiploma = await $http.$get(`${process.env.strapiBaseUri}/api/${instance.attributes.prefix}-diplomas/${offreAlternance.attributes.diplome?.data?.id}?populate=niveauDiplome,sessions`);
        campusDiploma = campusDiploma.data;

        let sessionInfo = campusDiploma.attributes?.sessions;
        sessionInfo = sessionInfo.data;
        if (sessionInfo.length >= 1) {
            sessionInfo = sessionInfo.sort((a, b) => b - a)[0];
        };


        let bacSeries = await $http.$get(`${process.env.apiCrmServer}bac.php?query=series`);
        bacSeries = bacSeries.filter(bacSerie => bacSerie.serie);
        let bacs = await $http.$get(`${process.env.apiCrmServer}bac.php?query=bacs`);
        let displayedBacs = bacs;

        // let campusInfo = await $http.$get(`${process.env.strapiBaseUri}/api/${instance.attributes.prefix}-home-page?populate=banniereLogo`);
        // campusInfo = campusInfo.data;
        let campusInfo = store.state.campusInfo;

        let banniereLogoUrl = process.env.strapiBaseUri + campusInfo.attributes.banniereLogo?.data?.attributes?.url;

        let campusDiplomas = await $http.$get(`${process.env.strapiBaseUri}/api/${instance.attributes.prefix}-diplomas`);
        campusDiplomas = campusDiplomas.data;
        const diplomaInfo = campusDiplomas.filter((diploma) => {
            return diploma.attributes.acronyme == params.diploma
        })[0];
        let collone1Diplomas = campusDiplomas.filter((diploma) => {
            return diploma.attributes.collone === 'Collone_1';
        })
        collone1Diplomas = collone1Diplomas.sort((d1, d2) => {
            return d1.attributes.ordre - d2.attributes.ordre
        })
        let collone2Diplomas = campusDiplomas.filter((diploma) => {
            return diploma.attributes.collone === 'Collone_2';
        })
        collone2Diplomas = collone2Diplomas.sort((d1, d2) => {
            return d1.attributes.ordre - d2.attributes.ordre
        })
        let collone3Diplomas = campusDiplomas.filter((diploma) => {
            return diploma.attributes.collone === 'Collone_3';
        })
        collone3Diplomas = collone3Diplomas.sort((d1, d2) => {
            return d1.attributes.ordre - d2.attributes.ordre
        })


        return {
            params, offreAlternance, campusDiploma, detailInfo, sessionInfo, instances, campusInfo, instance,
            campusDiplomas, collone1Diplomas, collone2Diplomas, collone3Diplomas, displayedBacs, bacs, bacSeries,
            banniereLogoUrl
        }
    },

}
